;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"
import {
  UI_STYLE_PRIMARY_BLUE_BLACK,
  UI_STYLE_PRIMARY_FONT,
} from "../../../../../lib/constants"

const CustomButton = styled(Button)(({ theme }) => ({
  boxShadow: "none",
  minWidth: "36px",
  minHeight: "36px",
  fontFamily: UI_STYLE_PRIMARY_FONT,
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "19px",
  textAlign: "center",
  letterSpacing: "0.03em",
  color: UI_STYLE_PRIMARY_BLUE_BLACK,
  textTransform: "unset",
  padding: "9px 15px",
  border: `1px solid ${UI_STYLE_PRIMARY_BLUE_BLACK}`,
  borderRadius: "100px",
  "@media only screen and (min-width: 600px)": {
    fontSize: "14px",
  },
  "&:hover": {
    backgroundColor: "rgb(9, 44, 60, 0.08)",
    borderColor: UI_STYLE_PRIMARY_BLUE_BLACK,
    filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25))",
  },
}))

function SecondaryButtonTitle({
  onClick,
  href,
  text,
}: {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  href?: string
  text: string
}) {
  return (
    <CustomButton variant="outlined" href={href} onClick={onClick}>
      {text}
    </CustomButton>
  )
}

export default SecondaryButtonTitle
